<template>
  <v-dialog
    v-model="computedSignshopSignageVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('signshop', 'signage', false);
            disable_edit = true;
            base64image = null;
            imageIndexOffset = 0;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>Mountain Sign Structure</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- zoomto icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates,
                level: 18
              });
              methodCloseListLayer('signshop', 'signage');
              methodToggleSingleLayer('signshop', 'signage', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>

        <!-- edit/delete icons -->
        <v-tooltip bottom>
          <v-btn
            :disabled="disable_edit"
            icon
            slot="activator"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            v-if="disable_edit"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-else
            color="info"
            icon
            slot="activator"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedSignshopSignageGeoJsonFeature"
          :loading="computedSignshopSignageLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="2">
                <v-tooltip bottom>
                  <v-btn
                    :disabled="
                      imageIndexOffset + computedImageUrl.filename.length === 1
                    "
                    icon
                    slot="activator"
                    @click="--imageIndexOffset"
                  >
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <span>Back</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    :disabled="
                      imageIndexOffset + computedImageUrl.filename.length ===
                        computedImageUrl.filename.length
                    "
                    icon
                    slot="activator"
                    @click="++imageIndexOffset"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                  <span>Forward</span>
                </v-tooltip>
                <span
                  v-if="
                    imageIndexOffset + computedImageUrl.filename.length !==
                      computedImageUrl.filename.length
                  "
                  >You are viewing a historical image
                  {{
                    computedImageUrl.filename[
                      imageIndexOffset + computedImageUrl.filename.length - 1
                    ].created
                      ? ` uploaded on ${
                          computedImageUrl.filename[
                            imageIndexOffset +
                              computedImageUrl.filename.length -
                              1
                          ].created.split("T")[0]
                        }`
                      : ""
                  }}</span
                >
                <span v-else
                  >You are viewing the latest image
                  {{
                    computedImageUrl.filename[
                      imageIndexOffset + computedImageUrl.filename.length - 1
                    ].created
                      ? ` uploaded on ${
                          computedImageUrl.filename[
                            imageIndexOffset +
                              computedImageUrl.filename.length -
                              1
                          ].created.split("T")[0]
                        }`
                      : ""
                  }}</span
                >
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <span
                  v-if="
                    computedImageUrl !=
                      'https://api2.alchemymapping.com/images/null'
                  "
                >
                  <img
                    style="max-height: 90vh; max-width: 90vw;"
                    :src="
                      `https://api2.alchemymapping.com/images/${
                        computedImageUrl.filename[
                          imageIndexOffset +
                            computedImageUrl.filename.length -
                            1
                        ].filename
                      }`
                    "
                  />
                </span>
              </td>
            </tr>
            <tr v-if="!disable_edit && imageIndexOffset === 0">
              <td>Update Image</td>
              <td>
                <image-uploader
                  @input="setOutput"
                  :quality="0.7"
                  :autoRotate="attemptAutoRotate"
                  outputFormat="base64"
                  class="fileinput2"
                  :preview="true"
                  accept=".jpg"
                  :key="attemptAutoRotate"
                />
              </td>
            </tr>
            <tr v-if="!disable_edit && imageIndexOffset === 0">
              <td>EXIF rotate?</td>
              <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
            </tr>
            <tr>
              <td>Structure Number</td>
              <td>
                <v-text-field
                  ref="signage_struct_num"
                  v-model="props.item.properties.struct_num"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Mountain</td>
              <td>
                <v-select
                  :items="opt_mountain"
                  ref="signage_mountain"
                  v-model="props.item.properties.mountain"
                  :label="props.item.properties.mountain"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Zone</td>
              <td>
                <v-text-field
                  ref="signage_zone"
                  v-model="props.item.properties.zone"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Run</td>
              <td>
                <v-text-field
                  ref="signage_run"
                  v-model="props.item.properties.run"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Condition</td>
              <td>
                <v-select
                  :items="opt_condition"
                  ref="signage_condition"
                  v-model="props.item.properties.condition"
                  :label="props.item.properties.condition"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Notes</td>
              <td>
                <v-textarea
                  ref="signage_notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <template>
                  <v-expansion-panel flat>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div style="max-width: 100;">
                          <v-btn color="primary" small
                            >Technical Information</v-btn
                          >
                        </div>
                      </template>
                      <v-card>
                        <v-data-table
                          :items="computedSignshopSignageGeoJsonFeature"
                          :loading="computedSignshopSignageLoading"
                          :hide-actions="hideactions"
                          :hide-headers="hideheaders"
                          class="elevation-0"
                        >
                          <template v-slot:items="props">
                            <tr>
                              <td>Sign Owner</td>
                              <td>
                                <v-select
                                  :items="opt_user_group"
                                  ref="signage_user_group"
                                  v-model="props.item.properties.user_group"
                                  :label="props.item.properties.user_group"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Purpose</td>
                              <td>
                                <v-select
                                  :items="opt_st_purpose"
                                  ref="signage_st_purpose"
                                  v-model="props.item.properties.st_purpose"
                                  :label="props.item.properties.st_purpose"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Information</td>
                              <td>
                                <v-checkbox
                                  ref="signage_blue"
                                  label="Blue"
                                  v-model="computedBlue"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_green"
                                  label="Green"
                                  v-model="form.green"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_black"
                                  label="Black"
                                  v-model="form.black"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_t_park"
                                  label="Terrain Park"
                                  v-model="form.t_park"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_low_light"
                                  label="Low Light"
                                  v-model="form.low_light"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_lift"
                                  label="Lift"
                                  v-model="form.lift"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_restaurant"
                                  label="Restaraunt"
                                  v-model="form.restaurant"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_racecentre"
                                  label="Race Centre"
                                  v-model="form.racecentre"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_strat_alli"
                                  label="Strategic Alliance"
                                  v-model="form.strat_alli"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_parking"
                                  label="Parking"
                                  v-model="form.parking"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_map"
                                  label="Map"
                                  v-model="form.telus"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_led"
                                  label="LED Screen"
                                  v-model="form.led"
                                  :disabled="disable_edit"
                                ></v-checkbox>
                              </td>
                            </tr>
                            <tr>
                              <td>Banner Size</td>
                              <td>
                                <v-text-field
                                  ref="signage_bannersize"
                                  v-model="props.item.properties.bannersize"
                                  :disabled="disable_edit"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>Structure Size</td>
                              <td>
                                <v-text-field
                                  ref="signage_structsize"
                                  v-model="props.item.properties.structsize"
                                  :disabled="disable_edit"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>Damage Type</td>
                              <td>
                                <v-select
                                  :items="opt_dmg_type"
                                  ref="signage_dmg_type"
                                  v-model="props.item.properties.dmg_type"
                                  :label="props.item.properties.dmg_type"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Action</td>
                              <td>
                                <v-checkbox
                                  ref="signage_a_paint"
                                  label="Paint"
                                  v-model="form.a_paint"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_a_repair"
                                  label="Repair"
                                  v-model="form.a_repair"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_a_f_insum"
                                  label="Fix in summer"
                                  v-model="form.a_f_insum"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_a_f_inwin"
                                  label="Fix in winter"
                                  v-model="form.a_f_inwin"
                                  :disabled="disable_edit"
                                ></v-checkbox>

                                <v-checkbox
                                  ref="signage_a_na"
                                  label="N/A"
                                  v-model="form.a_na"
                                  :disabled="disable_edit"
                                ></v-checkbox>
                              </td>
                            </tr>
                            <tr>
                              <td>On a Building?</td>
                              <td>
                                <v-select
                                  :items="opt_building"
                                  ref="signage_building"
                                  v-model="props.item.properties.building"
                                  :label="props.item.properties.building"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Building</td>
                              <td>
                                <v-text-field
                                  ref="signage_bldg_name"
                                  v-model="props.item.properties.bldg_name"
                                  :disabled="disable_edit"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>Season</td>
                              <td>
                                <v-select
                                  :items="opt_season"
                                  ref="signage_season"
                                  v-model="props.item.properties.season"
                                  :label="props.item.properties.season"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Flip/Change Seasonally</td>
                              <td>
                                <v-select
                                  :items="opt_flip"
                                  ref="signage_flip"
                                  v-model="props.item.properties.flip"
                                  :label="props.item.properties.flip"
                                  :disabled="disable_edit"
                                ></v-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Install Date</td>
                              <td>
                                <v-text-field
                                  ref="signage_instal_dt"
                                  v-model="props.item.properties.instal_dt"
                                  :disabled="disable_edit"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>Last Edited</td>
                              <td>
                                <span v-if="disable_edit">
                                  {{ props.item.properties.edit_by }}
                                </span>
                                <span v-if="!disable_edit">
                                  {{ computedAuth.profile.email }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>Modified</td>
                              <td>{{ props.item.properties.modified }}</td>
                            </tr>
                            <tr>
                              <td>Accuracy</td>
                              <td>{{ props.item.properties.accuracy }} m</td>
                            </tr>
                            <tr>
                              <td>Coordinates</td>
                              <td>
                                {{
                                  props.item.geometry.coordinates[0] +
                                    ", " +
                                    props.item.geometry.coordinates[1]
                                }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <!-- if submitting new image -->
                <v-btn
                  v-if="base64image"
                  @click.stop="
                    methodEditImageSignshopSignageGeoJson({
                      struct_num: $refs.signage_struct_num.value,
                      mountain: $refs.signage_mountain.value,
                      zone: $refs.signage_zone.value,
                      run: $refs.signage_run.value,
                      condition: $refs.signage_condition.value,
                      user_group: $refs.signage_user_group.value,
                      st_purpose: $refs.signage_st_purpose.value,
                      bannersize: $refs.signage_bannersize.value,
                      structsize: $refs.signage_structsize.value,
                      dmg_type: $refs.signage_dmg_type.value,
                      building: $refs.signage_building.value,
                      bldg_name: $refs.signage_bldg_name.value,
                      season: $refs.signage_season.value,
                      flip: $refs.signage_flip.value,
                      instal_dt: $refs.signage_instal_dt.value,
                      notes: $refs.signage_notes.value,
                      edit_by: computedAuth.profile.email,
                      a_paint: methodToNum(form.a_paint),
                      a_repair: methodToNum(form.a_repair),
                      a_f_insum: methodToNum(form.a_f_insum),
                      a_f_inwin: methodToNum(form.a_f_inwin),
                      a_na: methodToNum(form.a_na),
                      blue: methodToNum(form.blue),
                      green: methodToNum(form.green),
                      black: methodToNum(form.black),
                      t_park: methodToNum(form.t_park),
                      low_light: methodToNum(form.low_light),
                      lift: methodToNum(form.lift),
                      restaurant: methodToNum(form.restaurant),
                      racecentre: methodToNum(form.racecentre),
                      strat_alli: methodToNum(form.strat_alli),
                      //telus: methodToNum(form.telus),
                      parking: methodToNum(form.parking),
                      map: methodToNum(form.map),
                      led: methodToNum(form.led)
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('signshop', 'signage', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <!-- if not changing image -->
                <v-btn
                  v-else
                  @click.stop="
                    methodEditSignshopSignageGeoJson({
                      struct_num: $refs.signage_struct_num.value,
                      mountain: $refs.signage_mountain.value,
                      zone: $refs.signage_zone.value,
                      run: $refs.signage_run.value,
                      condition: $refs.signage_condition.value,
                      user_group: $refs.signage_user_group.value,
                      st_purpose: $refs.signage_st_purpose.value,
                      bannersize: $refs.signage_bannersize.value,
                      structsize: $refs.signage_structsize.value,
                      dmg_type: $refs.signage_dmg_type.value,
                      building: $refs.signage_building.value,
                      bldg_name: $refs.signage_bldg_name.value,
                      season: $refs.signage_season.value,
                      flip: $refs.signage_flip.value,
                      instal_dt: $refs.signage_instal_dt.value,
                      notes: $refs.signage_notes.value,
                      edit_by: computedAuth.profile.email,
                      a_paint: methodToNum(form.a_paint),
                      a_repair: methodToNum(form.a_repair),
                      a_f_insum: methodToNum(form.a_f_insum),
                      a_f_inwin: methodToNum(form.a_f_inwin),
                      a_na: methodToNum(form.a_na),
                      blue: methodToNum(form.blue),
                      green: methodToNum(form.green),
                      black: methodToNum(form.black),
                      t_park: methodToNum(form.t_park),
                      low_light: methodToNum(form.low_light),
                      lift: methodToNum(form.lift),
                      restaurant: methodToNum(form.restaurant),
                      racecentre: methodToNum(form.racecentre),
                      strat_alli: methodToNum(form.strat_alli),
                      // telus: methodToNum(form.telus),
                      parking: methodToNum(form.parking),
                      map: methodToNum(form.map),
                      led: methodToNum(form.led)
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('signshop', 'signage', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >

                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              methodDeleteSignshopSignageGeoJson();
              confirm_delete = false;
              disable_edit = true;
              imageIndexOffset = 0;
              methodToggleSingleLayer('signshop', 'signage', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
.content {
  max-height: 100%;
  max-width: 100%;
  padding: 0px !important;
  display: inline-block;
}
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      imageIndexOffset: 0,
      attemptAutoRotate: true,
      confirm_delete: false,
      base64image: null,
      form: {
        a_na: this.computedANA,
        a_repair: this.computedRepair,
        a_f_insum: this.computedInsum,
        a_f_inwin: this.computedInwin,
        blue: this.computedBlue,
        green: this.computedGreen,
        black: this.computedBlak,
        t_park: this.computedTPark,
        low_light: this.computedLowlight,
        lift: this.computedLift,
        restaurant: this.computedRestaurant,
        racecentre: this.computedRacecentre,
        strat_alli: this.computedStratAlli,
        // telus: this.computedTelus,
        map: this.computedMap,
        led: this.computedLed,
        parking: this.computedParking
      },
      ANA: false,
      checked: true,
      imageViewer: false,
      imageFilename: "",
      imageDesc: "",
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      disable_edit: true,
      opt_condition: [
        { text: "Good" },
        { text: "Poor" },
        { text: "Damaged" },
        { text: "Proposed" },
        { text: "Remove" },
        { text: "Look At" }
      ],
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      opt_st_purpose: [
        { text: "Information Board" },
        { text: "Directional - Information Board" },
        { text: "Directional - Banner" },
        { text: "Directional" },
        { text: "Banner - Information Board" },
        { text: "Banner" },
        { text: "Unknown" }
      ],
      opt_dmg_type: [
        { text: "Human" },
        { text: "Natural" },
        { text: "Unknown" }
      ],
      opt_sign_type: [
        { text: "Trail Sign" },
        { text: "Safety" },
        { text: "Map" },
        { text: "Light Map" },
        { text: "Light Board" },
        { text: "Grooming" },
        { text: "Digital" },
        { text: "Banner" },
        { text: "Unknown" }
      ],
      opt_building: [{ text: "Yes" }, { text: "No" }],
      opt_season: [
        { text: "Winter" },
        { text: "Summer" },
        { text: "Both" },
        { text: "Unknown" }
      ],
      opt_flip: [{ text: "Yes" }, { text: "No" }, { text: "Unknown" }],
      opt_user_group: [
        { text: "Permanent Sign Shop" },
        { text: "Summer Hiking" },
        { text: "EOL" },
        { text: "Other Departments" },
        { text: "Legal" },
        { text: "Maintenance & Operations" },
        { text: "Product Sales & Service" },
        { text: "IT" },
        { text: "Food & Beverage" },
        { text: "Marketing & Sales" },
        { text: "Retail Rental" },
        { text: "Snow School" },
        { text: "Base Area Operations" }
      ]
    };
  },
  computed: {
    computedImageUrl() {
      return (
        // "https://api2.alchemymapping.com/images/" +
        // this.$store.state.ui.image.filename
        this.$store.state.ui.image.filename
      );
    },
    computedSignshopSignageGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.signshop.layers.signage.geojson.features
      ) {
        const signage = this.$store.state.mapLayers.signshop.layers.signage
          .geojson.features;
        const result = signage.filter(
          item => item.properties.id == this.computedSignshopSignageId
        );
        return result;
      }
      return [];
    },
    computedLatLng() {
      if (
        this.$store.state.mapLayers.signshop.layers.signage.geojson.features
      ) {
        const signage = this.$store.state.mapLayers.signshop.layers.signage
          .geojson.features;
        const result = signage.filter(
          item => item.properties.id == this.computedSignshopSignageId
        );
        return result;
      }
      return [];
    },
    computedBlue: {
      get() {
        let json = this.computedSignshopSignageGeoJsonFeature;
        if (json[0].properties.blue == "0") {
          return false;
        } else {
          return true;
        }
      },
      set() {
        this.form.blue = this.$refs.signage_blue;
      }
    },
    computedGreen() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.green == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedBlak() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.black == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedTPark() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.t_park == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedLowlight() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.low_light == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedLift() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.lift == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedRestaurant() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.restaurant == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedRacecentre() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.racecentre == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedStratAlli() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.strat_alli == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedMap() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.map == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedLed() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.led == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedParking() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.parking == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedANA() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.a_na == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedPaint() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.a_paint == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedRepair() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.a_repair == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedInsum() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.a_f_insum == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedInwin() {
      let json = this.computedSignshopSignageGeoJsonFeature;
      if (json[0].properties.a_f_inwin == "0") {
        return false;
      } else {
        return true;
      }
    },
    computedSignshopSignageVisibility() {
      return this.$store.state.mapLayers.signshop.layers.signage.visibility
        .singleView;
    },
    computedSignshopSignageLoading() {
      return this.$store.state.mapLayers.signshop.layers.signage.loading;
    },
    computedSignshopSignageId() {
      return this.$store.state.mapLayers.signshop.layers.signage.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodDeleteSignshopSignageGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/signshop/signage/" +
            this.computedSignshopSignageId,
          dept: "signshop",
          layer: "signage",
          token: this.computedAuthToken
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetSignshopSignageGeoJson();
          }, 250);
        });
    },
    setOutput(file) {
      this.base64image = file;
    },
    methodToNum(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },
    methodViewSchematic(value) {
      this.imageFilename = value;
      this.imageViewer = true;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSignshopSignageGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/signshop/signage",
        dept: "signshop",
        layer: "signage",
        token: this.computedAuthToken
      });
    },
    methodEditSignshopSignageGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/signshop/signage/" +
          this.computedSignshopSignageId,
        dept: "signshop",
        layer: "signage",
        token: this.computedAuthToken,
        payload: data
      });
    },
    methodEditImageSignshopSignageGeoJson(data) {
      this.$store
        .dispatch("actionEditJsonImage", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/signshop/signage/" +
            this.computedSignshopSignageId,
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/signshop/signage/image",
          base64data: this.base64image,
          dept: "signshop",
          layer: "signage",
          token: this.computedAuthToken,
          payload: data,
          belongstoid: this.computedSignshopSignageId
        })
        .then(() => {
          this.base64image = null;
        });
    },
    methodGetImage() {
      this.$store.dispatch("actionGetImage", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/signshop/signage/image/" +
          this.computedSignshopSignageId,
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.signshop.layers.signage.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSignshopSignageGeoJson();
        this.methodGetImage();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.signshop.layers.signage.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
